import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import reducer from './reducer'
import * as constants from './constants'

export { reducer, constants }

export default Loadable(() => import('./CollateralDetails'))
